module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cc0065f74161f7e7859b31796aaa3345.svg";